module.exports = __webpack_public_path__ + "md.879bb31c43329e54330f.svg";


//////////////////
// WEBPACK FOOTER
// C:/Angular/projetos/RetycargasOfficialSite/src/assets/vendor/flag-icon-css-master/flags/1x1/md.svg
// module id = ../../../../../src/assets/vendor/flag-icon-css-master/flags/1x1/md.svg
// module chunks = styles